/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const BookEntryTypeEnum = Object.freeze({
	TITLE: "TITLE",
	CHAPTER: "CHAPTER",
	CONTENT: "CONTENT",
})

